import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

const FiltersContext = createContext(<React.Fragment />);

const FiltersReducerActions = {
  OPEN_DATES_FILTER: 'openDatesFilter',
  CLOSE_DATES_FILTER: 'closeDatesFilter'
};

const filtersReducer = (state, { type }) => {
  switch (type) {
    case FiltersReducerActions.OPEN_DATES_FILTER:
      return { ...state, shouldOpenDatesFilter: true };
    case FiltersReducerActions.CLOSE_DATES_FILTER:
      return { ...state, shouldOpenDatesFilter: false };
    default:
      throw Error(`[Filters Reducer] Unrecognized action: ${type}`);
  }
};

const FiltersProvider = ({ children }) => {
  const [filters, dispatch] = useReducer(filtersReducer, { shouldOpenDatesFilter: false });

  return <FiltersContext.Provider value={{ filters, dispatch }}>{children}</FiltersContext.Provider>;
};

FiltersProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

export { FiltersProvider, FiltersContext, FiltersReducerActions };
